// import darken from "./composed/darken.js";
// import swupInit from "./composed/swup.js";
import jarallax from "./composed/jarallax.js";
import gridzy from "./composed/gridzy/gridzy.js";
import BackgroundSourceSet from "./composed/BGSrcset.js";
import plyr from "./composed/plyr.js";
import matchheight from "./composed/match-height.js";
import placeholderLabels from "./composed/placeholder-labels.js";
import headerscroll from "./composed/headerscroll.js";
import uIkit from "./composed/uIkit.js";

document.addEventListener("DOMContentLoaded", firstLoadInit);

const bgss = new BackgroundSourceSet();
bgss.callonce = false;

// const swup = swupInit(".gn-swup-wrapper");

function genericInit() {
    headerscroll.init();
    // darken.init();
    gridzy.init();
    jarallax.init();
    plyr.init();
    matchheight.init();
    placeholderLabels.init();
    uIkit.init();

    const gnInitEvent = new Event("gnInit");
    document.dispatchEvent(gnInitEvent);

   


    //adding class to style search results page
    if (window.location.href.indexOf("&action_results=Go") > -1) {
        document.body.classList.remove("SolidMenu");
    }

    if (window.location.href.indexOf("?filter=") > -1) {
        document.body.classList.add("Show_SmartPag");
    }

    bgss.init(".BGImage", function (a) {
        a.node.classList.add("loaded");
    });
}


// Swup is disabled, so swap-only cleanup/rehydration hooks are intentionally inactive.

function firstLoadInit() {
    // if (window.location.href.indexOf("&action_results=Go") > -1) {
    //     document.body.classList.remove("SolidMenu");
    // }
    //
    // if (window.location.href.indexOf("?filter=") > -1) {
    //     document.body.classList.add("Show_SmartPag");
    // }

    genericInit();
}
